import { render, staticRenderFns } from "./AnisoFocusVisionTrend.vue?vue&type=template&id=da72c100&scoped=true&"
import script from "./AnisoFocusVisionTrend.vue?vue&type=script&lang=js&"
export * from "./AnisoFocusVisionTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da72c100",
  null
  
)

export default component.exports